import { Component, OnInit, inject } from '@angular/core';
import { IonAlert, IonIcon, IonItem, IonLabel } from '@ionic/angular/standalone';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AccountService } from '@okcargo-apps/shared-application-ionic';

@Component({
  selector: 'app-lang-select',
  templateUrl: './lang-select.component.html',
  styleUrls: ['./lang-select.component.scss'],
  imports: [IonAlert, IonLabel, IonIcon, IonItem, TranslateModule],
})
export class LangSelectComponent implements OnInit {
  private readonly translate = inject(TranslateService);
  private readonly accountService = inject(AccountService);

  private _defaultLang!: string;

  public alertButtons = [
    {
      text: '',
      role: 'confirm',
    },
  ];
  public alertInputs = [
    {
      label: '',
      type: 'radio',
      value: 'es',
    },
  ];

  ngOnInit(): void {
    this.accountService.account$.subscribe((account) => {
      if (account) {
        this._defaultLang = account.lang;
        this.assignButtonsAndInputsToAlert();
      }
    });
  }

  public async setLang(event: any): Promise<void> {
    if (event.detail.role === 'confirm') {
      const newLang = event.detail.data.values;
      this._defaultLang = newLang;
      try {
        await this.accountService.changeLang(newLang);
        this.assignButtonsAndInputsToAlert();
      } catch (error) {
        console.error('Error al cambiar el idioma:', error);
      }
    }
  }

  private assignButtonsAndInputsToAlert(): void {
    this.alertInputs = [
      {
        label: this.translate.instant('general.lang.es'),
        type: 'radio',
        value: 'es',
      },
      {
        label: this.translate.instant('general.lang.en'),
        type: 'radio',
        value: 'en',
      },
    ];
    this.alertButtons = [
      {
        text: this.translate.instant('general.select'),
        role: 'confirm',
      },
    ];
    this.alertInputs = this.alertInputs.map((lang) => {
      if (lang.value === this._defaultLang) {
        return { ...lang, checked: true };
      } else {
        return { ...lang, checked: false };
      }
    });
  }
}
